<template>
  <div class="app-root">
    <Nav />
    <main class="content">
      <router-view class="routerView" />
    </main>
    <HeiGeiFooter />
  </div>
</template>

<script>
import Nav from "./components/navigations-leiste.vue";
import HeiGeiFooter from "./components/heigei-footer.vue";

export default {
  components: {
    Nav,
    HeiGeiFooter,
  },
};
</script>

<style scoped>
.app-root {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.content {
  flex: 1;
  margin-block: 50px;
}

.routerView {
  margin-inline: 5%;
}
</style>